import axiosApiInstance from "../app/axios";
import { PARKIT_API_BASE_URL } from "../app/utils";
import { getJwtToken } from "../app/common";

export const getAllCarInsurance = async ({
  page,
  size,
  status,
  search,
  groupBy,
}) => {
  const params = new URLSearchParams({ page, size });
  // Omit status parameter when "ALL" is selected to fetch all records
  if (status && status !== "ALL") {
    params.append("status", status);
  }
  if (search != null) params.append("search", search);
  if (groupBy) params.append("groupBy", groupBy);
  return axiosApiInstance.get(
    `${PARKIT_API_BASE_URL}/parkit/v2/motor-quotations/admin-search?${params.toString()}`,
    { headers: { Authorization: `Bearer ${getJwtToken()}` } },
  );
};

export const deleteCarInsurance = async (id) =>
  axiosApiInstance.delete(`${PARKIT_API_BASE_URL}/parkit/v2/motor-quotations/${id}`, {
    headers: { Authorization: `Bearer ${getJwtToken()}` },
  });

export const downloadQuotationPdf = async (id) =>
  axiosApiInstance.get(
    `${PARKIT_API_BASE_URL}/parkit/v2/motor-quotations/${id}/quotation-pdf`,
    {
      headers: { Authorization: `Bearer ${getJwtToken()}` },
      responseType: "blob",
    }
  );

export const downloadEPolicy = async (id) =>
  axiosApiInstance.get(
    `${PARKIT_API_BASE_URL}/parkit/v2/motor-quotations/${id}/epolicy`,
    {
      headers: { Authorization: `Bearer ${getJwtToken()}` },
      responseType: "blob",
    }
  );

export const adminUpdateCarInsurance = async (id, request, ePolicyFile) => {
   const formData = new FormData();
   formData.append("request", new Blob([JSON.stringify(request)], { type: "application/json" }));
   if (ePolicyFile) {
     formData.append("epolicy", ePolicyFile);
   }
   return axiosApiInstance.post(
     `${PARKIT_API_BASE_URL}/parkit/v2/motor-quotations/${id}/admin-update`,
     formData,
     {
       headers: { Authorization: `Bearer ${getJwtToken()}` },
     },
   );
};

export const createQuotationFromEpolicy = async (username, ePolicyFile) => {
   const formData = new FormData();
   formData.append("epolicy", ePolicyFile);
   formData.append("username", username);
   return axiosApiInstance.post(
     `${PARKIT_API_BASE_URL}/parkit/v2/motor-quotations/admin-create-from-epolicy`,
     formData,
     {
       headers: { Authorization: `Bearer ${getJwtToken()}` },
     },
   );
};
